import styled from "styled-components";

const StyledArticle = styled.article`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export default StyledArticle;
